/**
 * Local store walk-through video paths.
 *
 * Drop .mp4 / .webm files into:
 *   client/public/store-profiles/walkthroughs/
 *
 * Filenames below are conventions — rename your files to match, or update the paths here.
 * Videos are served by Vite at /store-profiles/walkthroughs/<filename>
 *
 * Large files are gitignored by default; copy them locally for dev review.
 */

export const WALKTHROUGH_VIDEO_PATHS: Record<string, string> = {
  'walk-001': '/store-profiles/walkthroughs/supervalu-rathmines-front-aisles-1-6.mp4',
  'walk-002': '/store-profiles/walkthroughs/supervalu-rathmines-centre-aisles-7-10.mp4',
  'walk-003': '/store-profiles/walkthroughs/supervalu-rathmines-promo-aisles-11-12.mp4',
  'walk-004': '/store-profiles/walkthroughs/supervalu-rathmines-full-store-baseline.mp4',
};

export function resolveWalkthroughVideoUrl(walkthroughId: string, explicitUrl?: string): string | undefined {
  if (explicitUrl) return explicitUrl;
  return WALKTHROUGH_VIDEO_PATHS[walkthroughId];
}
